export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ChoiceInput: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type ActivationTemplate = {
  __typename?: 'ActivationTemplate';
  blob: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languages: Array<Language>;
  signatureType: SignatureType;
  templateName: Scalars['String']['output'];
};

export type AddChoiceArgs = {
  form: Scalars['JSON']['input'];
  payments: Array<Payment>;
  productId: Scalars['ID']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ArrDataPoint = {
  __typename?: 'ArrDataPoint';
  amount: Scalars['Float']['output'];
  period: Scalars['String']['output'];
};

export type ArrReport = {
  __typename?: 'ArrReport';
  chartData: Array<ArrDataPoint>;
  lastDeal: Deal;
  optimisticMultiplier: Scalars['Float']['output'];
  pessimisticMultiplier: Scalars['Float']['output'];
  realisticMultiplier: Scalars['Float']['output'];
  totalCompanyShares: Scalars['Float']['output'];
};

export type AskEarlyCashoutArgs = {
  amount: Scalars['Float']['input'];
  budgetId: Scalars['ID']['input'];
  estimatedGross: Scalars['Float']['input'];
  estimatedNet: Scalars['Float']['input'];
};

export type BareInput = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type Blob = {
  __typename?: 'Blob';
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storageServiceProvider: StorageServiceProvider;
  tenant: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BooleanInput = BareInput & {
  __typename?: 'BooleanInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type Budget = {
  __typename?: 'Budget';
  activationStatus: BudgetActivationStatus;
  activationTemplates: Array<Maybe<ActivationTemplate>>;
  cashOutCron?: Maybe<Scalars['String']['output']>;
  cashOutStartDate?: Maybe<Scalars['DateTime']['output']>;
  cashoutPaymentOptions?: Maybe<CashoutPaymentOptions>;
  choiceCycle: ChoiceCycle;
  code: BudgetCode;
  createdAt: Scalars['DateTime']['output'];
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: LocalizedText;
  products: Array<Scalars['String']['output']>;
  topUpCron?: Maybe<Scalars['String']['output']>;
  topUpStartDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BudgetActivation = {
  __typename?: 'BudgetActivation';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  active: Scalars['Boolean']['output'];
  budget: Budget;
  document: Document;
  id: Scalars['ID']['output'];
};

export type BudgetActivationStatus = {
  __typename?: 'BudgetActivationStatus';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  active: Scalars['Boolean']['output'];
};

export type BudgetAmount = {
  __typename?: 'BudgetAmount';
  amount: Scalars['Float']['output'];
  budgetId: Scalars['ID']['output'];
  committed: Scalars['Boolean']['output'];
  holidayCost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
};

export enum BudgetCode {
  CashBonus = 'CASH_BONUS',
  EndOfYearPremium = 'END_OF_YEAR_PREMIUM',
  ExtraHolidays = 'EXTRA_HOLIDAYS',
  LumpSum = 'LUMP_SUM',
  MobilityBudget = 'MOBILITY_BUDGET',
  SalesCommission = 'SALES_COMMISSION'
}

export type BudgetEligibility = {
  __typename?: 'BudgetEligibility';
  blockingProductId?: Maybe<Scalars['String']['output']>;
  ineligibilityReason?: Maybe<BudgetIneligibilityReason>;
};

export enum BudgetIneligibilityReason {
  BudgetNotActive = 'BUDGET_NOT_ACTIVE',
  EmployeeBudgetNotActivated = 'EMPLOYEE_BUDGET_NOT_ACTIVATED',
  ProductNotEligible = 'PRODUCT_NOT_ELIGIBLE'
}

export type BudgetSettings = {
  __typename?: 'BudgetSettings';
  automaticAmountCalculation: Scalars['Boolean']['output'];
};

export enum BudgetStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type CancelCheckout = {
  __typename?: 'CancelCheckout';
  cancelUrl: Scalars['String']['output'];
  checkoutId: Scalars['ID']['output'];
};

export type CashOutOrder = {
  __typename?: 'CashOutOrder';
  date: Scalars['DateTime']['output'];
  expectedAmount?: Maybe<Scalars['Float']['output']>;
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type CashoutPaymentOptions = {
  __typename?: 'CashoutPaymentOptions';
  cashOutPaymentType: Scalars['String']['output'];
  hasEarlyCashOut: Scalars['Boolean']['output'];
};

export type Checkout = ICheckout & {
  __typename?: 'Checkout';
  budgets: Array<EmployeeBudgetEligibility>;
  clientId: Scalars['String']['output'];
  /** Whether the checkout allows combining budgets, this is only possible if the product config allows it for each item */
  combiningBudgets: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CheckoutItemEligibility>;
  provider: Provider;
  /** The total budget impact of the checkout, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckoutBudgetSimulation = {
  __typename?: 'CheckoutBudgetSimulation';
  /** The impact on the budget(s) for a product */
  totalBudgetImpact: Scalars['Float']['output'];
  /** The tax advantage that an employee receives by choosing for a product via Payflip */
  totalNetAdvantage: Scalars['Float']['output'];
  /** How much the employee would receive net in cash if he would choose for cash with that budget */
  totalNetCashImpact: Scalars['Float']['output'];
  /** A yearly split of the budget impact and net cash impact */
  yearlyImpacts: Array<YearlyImpact>;
};

export type CheckoutCanceled = ICheckout & {
  __typename?: 'CheckoutCanceled';
  budgets: Array<EmployeeBudgetEligibility>;
  cancelUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  /** Whether the checkout allows combining budgets, this is only possible if the product config allows it for each item */
  combiningBudgets: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CheckoutItemEligibility>;
  provider: Provider;
  /** The total budget impact of the checkout, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckoutCompleted = ICheckout & {
  __typename?: 'CheckoutCompleted';
  budgets: Array<EmployeeBudgetEligibility>;
  clientId: Scalars['String']['output'];
  /** Whether the checkout allows combining budgets, this is only possible if the product config allows it for each item */
  combiningBudgets: Scalars['Boolean']['output'];
  completeUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CheckoutItemEligibility>;
  provider: Provider;
  /** The total budget impact of the checkout, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckoutEncryptedResult = Checkout | CheckoutCanceled | CheckoutCompleted | CheckoutExpired | CheckoutForbidden;

export type CheckoutExpired = ICheckout & {
  __typename?: 'CheckoutExpired';
  budgets: Array<EmployeeBudgetEligibility>;
  clientId: Scalars['String']['output'];
  /** Whether the checkout allows combining budgets, this is only possible if the product config allows it for each item */
  combiningBudgets: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiredAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CheckoutItemEligibility>;
  provider: Provider;
  /** The total budget impact of the checkout, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CheckoutForbidden = ICheckout & {
  __typename?: 'CheckoutForbidden';
  budgets: Array<EmployeeBudgetEligibility>;
  cancelUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  /** Whether the checkout allows combining budgets, this is only possible if the product config allows it for each item */
  combiningBudgets: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CheckoutItemEligibility>;
  provider: Provider;
  reason: CheckoutForbiddenReason;
  /** The total budget impact of the checkout, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CheckoutForbiddenReason {
  InvalidProduct = 'INVALID_PRODUCT',
  ProductNotEligible = 'PRODUCT_NOT_ELIGIBLE'
}

export type CheckoutItemBudgetSimulation = {
  __typename?: 'CheckoutItemBudgetSimulation';
  /** The impact on the budget(s) for a product */
  totalBudgetImpact: Scalars['Float']['output'];
  /** The tax advantage that an employee receives by choosing for a product via Payflip */
  totalNetAdvantage: Scalars['Float']['output'];
  /** How much the employee would receive net in cash if he would choose for cash with that budget */
  totalNetCashImpact: Scalars['Float']['output'];
  /** A yearly split of the budget impact and net cash impact */
  yearlyImpacts: Array<YearlyImpact>;
};

export type CheckoutItemEligibility = ICheckoutItem & {
  __typename?: 'CheckoutItemEligibility';
  checkoutId: Scalars['String']['output'];
  eligibility: ProductEligibility;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  productInfo: ProductInfo;
  /** The total budget impact of the checkout item, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  useTermsAndConditions: Scalars['Boolean']['output'];
};

export type CheckoutPayment = {
  amount: Scalars['Float']['input'];
  budget: Scalars['ID']['input'];
};

export type Choice = {
  __typename?: 'Choice';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  choiceFunding?: Maybe<ChoiceFunding>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  employee: Employee;
  formInputs: Array<FormInput>;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  product: Product;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<ChoiceSource>;
  status: ChoiceStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  transactions: Array<Transaction>;
};


export type ChoiceTransactionsArgs = {
  status?: InputMaybe<Array<TransactionStatusType>>;
};

export type ChoiceContextArgs = {
  productId: Scalars['ID']['input'];
};

export type ChoiceContextResponse = {
  __typename?: 'ChoiceContextResponse';
  context: Scalars['JSON']['output'];
};

export type ChoiceCycle = {
  __typename?: 'ChoiceCycle';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status: BudgetStatus;
};

export type ChoiceFunding = {
  __typename?: 'ChoiceFunding';
  budgetImpact: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  paymentsSchedule: Array<PaymentsScheduleOrder>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ChoiceIneligibilityReason {
  AlreadyChosenBenefit = 'ALREADY_CHOSEN_BENEFIT',
  AlreadyChosenProduct = 'ALREADY_CHOSEN_PRODUCT',
  AlreadyChosenProductInList = 'ALREADY_CHOSEN_PRODUCT_IN_LIST',
  MissingRequiredBenefit = 'MISSING_REQUIRED_BENEFIT'
}

export enum ChoiceSource {
  AutoRenewal = 'AUTO_RENEWAL',
  Import = 'IMPORT',
  Manual = 'MANUAL'
}

export enum ChoiceStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Selected = 'SELECTED',
  Submitted = 'SUBMITTED'
}

export type ChoiceSubmissionIneligibilityReason = {
  __typename?: 'ChoiceSubmissionIneligibilityReason';
  blockingChoiceId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  bankAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CompanyDocumentType {
  File = 'FILE',
  Url = 'URL'
}

export type CompleteCheckout = {
  __typename?: 'CompleteCheckout';
  checkoutId: Scalars['ID']['output'];
  completeUrl: Scalars['String']['output'];
};

export type CompleteCheckoutArgs = {
  checkoutId: Scalars['ID']['input'];
  items?: InputMaybe<Array<CompleteCheckoutItem>>;
  /** A list of budget and the associated amount to use */
  payments?: InputMaybe<Array<CheckoutPayment>>;
};

export type CompleteCheckoutItem = {
  itemId: Scalars['ID']['input'];
  /** A list of budget and the associated amount to use */
  payments: Array<Payment>;
};

export type CostInHolidaysArgs = {
  formInputs: Scalars['JSON']['input'];
  productId: Scalars['ID']['input'];
};

export type CounterInput = BareInput & {
  __typename?: 'CounterInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  fixedSteps?: Maybe<Array<Scalars['Float']['output']>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export enum Currency {
  Eur = 'EUR'
}

export type CurrencyFieldValue = FieldValue & {
  __typename?: 'CurrencyFieldValue';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: CurrencyFieldValue;
};

export type CurrencyInput = BareInput & {
  __typename?: 'CurrencyInput';
  currency: Currency;
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type DateFieldValue = FieldValue & {
  __typename?: 'DateFieldValue';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DateInput = BareInput & {
  __typename?: 'DateInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type DateRangeInput = BareInput & {
  __typename?: 'DateRangeInput';
  dateFromName: Scalars['String']['output'];
  dateToName: Scalars['String']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type Deal = {
  __typename?: 'Deal';
  amount: Scalars['Float']['output'];
  closedate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DeskChairProductInfo = ProductInfo & {
  __typename?: 'DeskChairProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type DeskTableProductInfo = ProductInfo & {
  __typename?: 'DeskTableProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Document = {
  __typename?: 'Document';
  active: Scalars['Boolean']['output'];
  blob?: Maybe<Blob>;
  category: Scalars['String']['output'];
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  employee?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  languages: Array<Language>;
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  type: CompanyDocumentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentInput = BareInput & {
  __typename?: 'DocumentInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type EditChoiceArgs = {
  choiceId: Scalars['ID']['input'];
  form: Scalars['JSON']['input'];
  payments: Array<Payment>;
};

export type EditUserAddressArgs = {
  city: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type Employee = {
  __typename?: 'Employee';
  budgetActivations: Array<BudgetActivation>;
  budgets: Array<EmployeeBudget>;
  company: Company;
  employerNsso: Scalars['Float']['output'];
  holidayCost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  onboarded: Scalars['Boolean']['output'];
  startDateEmployer: Scalars['DateTime']['output'];
  tenant: Scalars['String']['output'];
  totalNetAdvantage: Scalars['Float']['output'];
  user: User;
};


export type EmployeeTotalNetAdvantageArgs = {
  choiceStatuses?: InputMaybe<Array<ChoiceStatus>>;
};

export type EmployeeBudget = {
  __typename?: 'EmployeeBudget';
  balance: Scalars['Float']['output'];
  budget: Budget;
  cashOutOrders: Array<CashOutOrder>;
  currentTopUpOrder?: Maybe<TopUpOrder>;
  nextCashOutOrder?: Maybe<CashOutOrder>;
  nextTopUpOrder?: Maybe<TopUpOrder>;
  paymentOrders: Array<PaymentOrder>;
  settings: BudgetSettings;
  topUpOrders: Array<TopUpOrder>;
  transactions: Array<Transaction>;
};

export type EmployeeBudgetEligibility = {
  __typename?: 'EmployeeBudgetEligibility';
  eligibility: BudgetEligibility;
  employeeBudget: EmployeeBudget;
};

export type FieldValue = {
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FormInput = {
  __typename?: 'FormInput';
  key: Scalars['String']['output'];
  value: Scalars['ChoiceInput']['output'];
};

export type GrossCashArgs = {
  budgetAmount: Scalars['Float']['input'];
  budgetId: Scalars['ID']['input'];
};

export type HiddenInput = BareInput & {
  __typename?: 'HiddenInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type ICheckout = {
  budgets: Array<EmployeeBudgetEligibility>;
  clientId: Scalars['String']['output'];
  /** Whether the checkout allows combining budgets, this is only possible if the product config allows it for each item */
  combiningBudgets: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CheckoutItemEligibility>;
  provider: Provider;
  /** The total budget impact of the checkout, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ICheckoutItem = {
  checkoutId: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  productId: Scalars['String']['output'];
  productInfo: ProductInfo;
  /** The total budget impact of the checkout item, this is the amount that needs to be financed by the budget(s) */
  totalBudgetImpact: Scalars['Float']['output'];
  useTermsAndConditions: Scalars['Boolean']['output'];
};

export type InsuranceProductInfo = ProductInfo & {
  __typename?: 'InsuranceProductInfo';
  /** End date in format YYYY-MM-DD */
  endDate: Scalars['String']['output'];
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  /** Start date in format YYYY-MM-DD */
  startDate: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum Language {
  En = 'en',
  Fr = 'fr',
  Nl = 'nl'
}

export type LocalizedText = {
  __typename?: 'LocalizedText';
  en: Scalars['String']['output'];
  fr?: Maybe<Scalars['String']['output']>;
  nl?: Maybe<Scalars['String']['output']>;
};

export type LongTextFieldValue = FieldValue & {
  __typename?: 'LongTextFieldValue';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateEmployeeBudget: Scalars['ID']['output'];
  addChoice: Choice;
  askEarlyCashOut: CashOutOrder;
  cancelCheckout: CancelCheckout;
  completeCheckout: CompleteCheckout;
  editChoice: Choice;
  editFunding: Choice;
  editUserAddress: User;
  fundingAttachmentSignatureUrl: Scalars['String']['output'];
  onboard: Employee;
  removeChoice: Scalars['ID']['output'];
  sendEmailVerificationEmail: SendEmailVerificationEmailResponse;
  setUserLanguage: User;
  stopImpersonate: StopImpersonateResponse;
  submitSelectedChoices: SubmitSelectedChoicesResult;
  upsertStockOptions: StockOptions;
};


export type MutationActivateEmployeeBudgetArgs = {
  blobId: Scalars['ID']['input'];
  budgetId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationAddChoiceArgs = {
  addChoiceArgs: AddChoiceArgs;
};


export type MutationAskEarlyCashOutArgs = {
  askEarlyCashoutArgs: AskEarlyCashoutArgs;
};


export type MutationCancelCheckoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteCheckoutArgs = {
  completeCheckoutArgs: CompleteCheckoutArgs;
};


export type MutationEditChoiceArgs = {
  editChoiceArgs: EditChoiceArgs;
};


export type MutationEditFundingArgs = {
  choiceId: Scalars['ID']['input'];
  payments: Array<Payment>;
};


export type MutationEditUserAddressArgs = {
  payload: EditUserAddressArgs;
};


export type MutationFundingAttachmentSignatureUrlArgs = {
  budgetId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationRemoveChoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetUserLanguageArgs = {
  language: Language;
};


export type MutationUpsertStockOptionsArgs = {
  input: UpsertStockOptionsInput;
};

export type NetCashArgs = {
  budgetAmount: Scalars['Float']['input'];
  budgetId: Scalars['ID']['input'];
};

export type NetValueArgs = {
  formInputs: Scalars['JSON']['input'];
  productId: Scalars['ID']['input'];
};

export type NumberInput = BareInput & {
  __typename?: 'NumberInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  automaticProcessing: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: OrderStatus;
  tenant: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrderStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type PcAccessoryProductInfo = ProductInfo & {
  __typename?: 'PCAccessoryProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type PcProductInfo = ProductInfo & {
  __typename?: 'PCProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Payment = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  budget: Scalars['ID']['input'];
};

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  budget: Budget;
  choice: Choice;
  committed: Scalars['Boolean']['output'];
  dueDate: Scalars['DateTime']['output'];
  employee: Employee;
  expectedAmount: Scalars['Float']['output'];
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  transactions: Array<Transaction>;
};

export type PaymentOrderArgs = {
  budgetId: Scalars['ID']['input'];
  choiceId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
};

export type PaymentsScheduleOrder = {
  __typename?: 'PaymentsScheduleOrder';
  amountPerBudget: Array<BudgetAmount>;
  dueDate: Scalars['DateTime']['output'];
  expectedAmount: Scalars['Float']['output'];
  fulfilled: Scalars['Boolean']['output'];
  part: Scalars['Float']['output'];
  transactionIds: Array<Maybe<Scalars['String']['output']>>;
};

export type PayrollEntry = {
  __typename?: 'PayrollEntry';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payrollOrder: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
  wageCode: Scalars['String']['output'];
};

/** The type of payroll line */
export enum PayrollLineType {
  Amount = 'AMOUNT',
  BenefitOfAllKind = 'BENEFIT_OF_ALL_KIND',
  BenefitOfAllKindRestValue = 'BENEFIT_OF_ALL_KIND_REST_VALUE',
  CashoutPayOut = 'CASHOUT_PAY_OUT',
  NotApplicable = 'NOT_APPLICABLE',
  PayOut = 'PAY_OUT'
}

export type PayrollOrder = {
  __typename?: 'PayrollOrder';
  archived: Scalars['Boolean']['output'];
  dueDate: Scalars['DateTime']['output'];
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: PayrollLineType;
  value: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  allowMultipleSelections: Scalars['Boolean']['output'];
  category: ProductCategory;
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledText: Scalars['String']['output'];
  eligibility: ProductEligibility;
  expiresOn?: Maybe<Scalars['DateTime']['output']>;
  fields: Array<ProductField>;
  hasCheckoutStep: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentType: ProductPaymentTypeType;
  steps: Scalars['JSON']['output'];
  taxAdvantage: ProductTaxAdvantageType;
  termsAndConditionsLink?: Maybe<Scalars['String']['output']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProductEligibility = {
  __typename?: 'ProductEligibility';
  blockingChoiceId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  ineligibilityReason?: Maybe<ChoiceIneligibilityReason>;
};

export type ProductField = {
  __typename?: 'ProductField';
  fallback?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  tag?: Maybe<ProductFieldTag>;
  type: ProductFieldType;
};

export enum ProductFieldTag {
  Action = 'ACTION',
  Count = 'COUNT',
  EndDate = 'END_DATE',
  MonthlyPrice = 'MONTHLY_PRICE',
  Price = 'PRICE',
  StartDate = 'START_DATE'
}

export enum ProductFieldType {
  Currency = 'CURRENCY',
  Date = 'DATE',
  File = 'FILE',
  LongText = 'LONG_TEXT',
  Text = 'TEXT',
  Url = 'URL'
}

export type ProductInfo = {
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export enum ProductPaymentTypeType {
  Depreciation = 'DEPRECIATION',
  Immediate = 'IMMEDIATE'
}

export enum ProductTaxAdvantageType {
  Bad = 'BAD',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Neutral = 'NEUTRAL',
  VeryGood = 'VERY_GOOD'
}

export type Provider = {
  __typename?: 'Provider';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<Product>;
};

export type Query = {
  __typename?: 'Query';
  arrReport: ArrReport;
  blob: Blob;
  budget: Budget;
  budgets: Array<Budget>;
  checkoutByEncryptedId: CheckoutEncryptedResult;
  choice: Choice;
  choiceContext: ChoiceContextResponse;
  choices: Array<Choice>;
  company: Company;
  costInHolidays: Scalars['Float']['output'];
  document: Document;
  documents: Array<Document>;
  employee: Employee;
  grossCash: Scalars['Float']['output'];
  netCash: Scalars['Float']['output'];
  netValue: Scalars['Float']['output'];
  paymentOrders: Array<PaymentOrder>;
  product: Product;
  products: Array<Product>;
  provider: Provider;
  providers: Array<Provider>;
  simulateCheckoutBudget: CheckoutBudgetSimulation;
  simulateCheckoutItemBudget: CheckoutItemBudgetSimulation;
  simulatedPaymentOrders: Array<PaymentsScheduleOrder>;
  stockOptions?: Maybe<StockOptions>;
  tenant: TenantContent;
  totalBudgetImpact: Scalars['Float']['output'];
  transaction: Transaction;
  transactions: Array<Transaction>;
  user: User;
};


export type QueryBlobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCheckoutByEncryptedIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryChoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChoiceContextArgs = {
  choiceContextArgs: ChoiceContextArgs;
};


export type QueryChoicesArgs = {
  status?: InputMaybe<Array<ChoiceStatus>>;
};


export type QueryCostInHolidaysArgs = {
  costInHolidaysArgs: CostInHolidaysArgs;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGrossCashArgs = {
  grossCashArgs: GrossCashArgs;
};


export type QueryNetCashArgs = {
  netCashArgs: NetCashArgs;
};


export type QueryNetValueArgs = {
  netValueArgs: NetValueArgs;
};


export type QueryPaymentOrdersArgs = {
  paymentOrderArgs: PaymentOrderArgs;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  budgetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySimulateCheckoutBudgetArgs = {
  simulatedPaymentOrdersArgs: SimulatedCheckoutPaymentOrdersArgs;
};


export type QuerySimulateCheckoutItemBudgetArgs = {
  simulatedPaymentOrdersArgs: SimulatedPaymentOrdersArgs;
};


export type QuerySimulatedPaymentOrdersArgs = {
  addChoiceArgs: AddChoiceArgs;
  choiceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTotalBudgetImpactArgs = {
  totalBudgetImpactArgs: TotalBudgetImpactArgs;
};


export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionsArgs = {
  budgetId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<TransactionStatusType>>;
};

export type RadioInput = BareInput & {
  __typename?: 'RadioInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type SelectInput = BareInput & {
  __typename?: 'SelectInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  selectInputOptions: Array<SelectOption>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  value: Scalars['String']['output'];
};

export type SendEmailVerificationEmailResponse = {
  __typename?: 'SendEmailVerificationEmailResponse';
  success: Scalars['Boolean']['output'];
};

export enum SignatureType {
  ESign = 'E_SIGN',
  Manual = 'MANUAL'
}

export type SimulatedCheckoutPaymentOrdersArgs = {
  checkoutId: Scalars['ID']['input'];
  /** A list of budget and the associated amount to use for the simulation */
  payments: Array<CheckoutPayment>;
};

export type SimulatedPaymentOrdersArgs = {
  checkoutItemId: Scalars['ID']['input'];
  /** A list of budget and the associated amount to use for the simulation */
  payments: Array<Payment>;
};

export type SmartphoneAccessoryProductInfo = ProductInfo & {
  __typename?: 'SmartphoneAccessoryProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type SmartphoneProductInfo = ProductInfo & {
  __typename?: 'SmartphoneProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type SmartwatchProductInfo = ProductInfo & {
  __typename?: 'SmartwatchProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type StockOptions = {
  __typename?: 'StockOptions';
  quantity: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  /** The percentage of vested shares to date */
  vested: Scalars['Float']['output'];
};

export type StopImpersonateResponse = {
  __typename?: 'StopImpersonateResponse';
  success: Scalars['Boolean']['output'];
};

export enum StorageServiceProvider {
  Azure = 'AZURE'
}

export type SubmitSelectedChoicesResult = ChoiceSubmissionIneligibilityReason | SubmittedChoices;

export type SubmittedChoices = {
  __typename?: 'SubmittedChoices';
  choices: Array<Choice>;
};

export type TabletAccessoryProductInfo = ProductInfo & {
  __typename?: 'TabletAccessoryProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type TabletProductInfo = ProductInfo & {
  __typename?: 'TabletProductInfo';
  extraFields: Array<FieldValue>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export enum Tenant {
  Acerta = 'ACERTA',
  Cipal = 'CIPAL',
  Liantis = 'LIANTIS',
  Payflip2 = 'PAYFLIP2'
}

export type TenantContent = {
  __typename?: 'TenantContent';
  code: Scalars['ID']['output'];
  privacyPolicyLink?: Maybe<Scalars['String']['output']>;
  termsAndConditionsLink?: Maybe<Scalars['String']['output']>;
};

export type TextAreaInput = BareInput & {
  __typename?: 'TextAreaInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type TextFieldValue = FieldValue & {
  __typename?: 'TextFieldValue';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TextInput = BareInput & {
  __typename?: 'TextInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type TopUpOrder = {
  __typename?: 'TopUpOrder';
  automaticAmountCalculation: Scalars['Boolean']['output'];
  committed: Scalars['Boolean']['output'];
  date: Scalars['DateTime']['output'];
  expectedAmount: Scalars['Float']['output'];
  fulfilled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type TotalBudgetImpactArgs = {
  formInputs: Scalars['JSON']['input'];
  productId: Scalars['ID']['input'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float']['output'];
  budget: Budget;
  choice?: Maybe<Choice>;
  createdAt: Scalars['DateTime']['output'];
  employee: Employee;
  holidayCost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  status: TransactionStatusType;
  tags: Array<Scalars['String']['output']>;
};

export enum TransactionStatusType {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type UrlFieldValue = FieldValue & {
  __typename?: 'URLFieldValue';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UpsertStockOptionsInput = {
  quantity: Scalars['Int']['input'];
};

export type UrlInput = BareInput & {
  __typename?: 'UrlInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  onlyEditableBySuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  tenants?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  authId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isImpersonated: Scalars['Boolean']['output'];
  language: Language;
  lastname: Scalars['String']['output'];
  tenant: Tenant;
};

export type YearlyImpact = {
  __typename?: 'YearlyImpact';
  budgetImpact: Scalars['Float']['output'];
  /** The number of holidays part of the budget impact, this can be null if the none of the budget are related to holidays */
  budgetImpactOfWhichHolidays?: Maybe<Scalars['Float']['output']>;
  netCashImpact: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};
